import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Location } from '../../@posturinn/client-react';
import { fetchLocations } from '../../actions/locationsActions';

const useLocations = () => {
	const dispatch = useDispatch<any>();
	const {
		locations,
		locationsError,
		locationsLoading,
	}: { locations: Location[]; locationsError: boolean; locationsLoading: boolean } = useSelector(
		({ locationsReducer }) => locationsReducer
	);
	useEffect(() => {
		if (locations === null && !locationsError && !locationsLoading) {
			dispatch(fetchLocations());
		}
	}, [locations, locationsError, locationsLoading, dispatch]);
	return {
		locations,
		locationsError,
		locationsLoading,
	};
};

export default useLocations;
